/**
 * Loads the member-safe projection of canonical course tees. An empty array is
 * meaningful only when the endpoint successfully returns it; transport, auth,
 * HTTP and malformed-payload failures reject instead.
 */
export async function fetchCanonicalGolfTees({ memberPortalApiGet, clubCode, courseId, signal }) {
  const response = await memberPortalApiGet(
    `/api/members-portal/${clubCode}/golf/courses/${encodeURIComponent(String(courseId))}/tees`,
    { signal },
  )
  const payload = await response.json().catch(() => null)
  if (!response.ok) {
    const error = new Error(payload?.error || `golf_tees_http_${response.status}`)
    error.status = response.status
    throw error
  }
  if (!Array.isArray(payload?.data)) throw new Error('invalid_golf_tees_response')
  return payload.data
}
